import React, { useRef, useState } from 'react';
import { supabase } from '../lib/supabase';
import { fileName } from '../utils/helpers';

// value is a comma-separated string of storage paths; onChange receives the updated string
export default function MultiFileUpload({ label, value, onChange, required, max = 10, accept = '.pdf,.jpg,.jpeg,.png' }) {
  const ref = useRef();
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState('');
  const paths = (value || '').split(',').filter(Boolean);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    if (paths.length + files.length > max) {
      setErr('Maximum ' + max + ' files allowed. You can add ' + (max - paths.length) + ' more.');
      return;
    }
    setUploading(true); setErr('');
    const newPaths = [...paths];
    for (const file of files) {
      const path = 'uploads/' + Date.now() + '_' + Math.random().toString(36).slice(2, 6) + '_' + file.name.replace(/\s+/g, '_');
      const { error } = await supabase.storage.from('payment-docs').upload(path, file);
      if (error) { setErr('Upload failed for ' + file.name + ': ' + error.message); }
      else newPaths.push(path);
    }
    onChange(newPaths.join(','));
    setUploading(false);
    if (ref.current) ref.current.value = '';
  };

  const removeFile = (p) => {
    onChange(paths.filter(x => x !== p).join(','));
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#444', marginBottom: 6 }}>
        {label}{required && <span style={{ color: '#A32D2D', marginLeft: 3 }}>*</span>}
        <span style={{ fontSize: 11, color: '#999', marginLeft: 8 }}>({paths.length}/{max} files)</span>
      </label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: paths.length ? 8 : 0 }}>
        <button type="button" onClick={() => ref.current.click()} disabled={uploading || paths.length >= max}
          style={{ padding: '7px 14px', background: '#f5f4f0', border: '1px solid #d3d1c7', borderRadius: 8, fontSize: 13, cursor: (uploading || paths.length >= max) ? 'not-allowed' : 'pointer', color: '#444', opacity: paths.length >= max ? 0.5 : 1 }}>
          {uploading ? 'Uploading…' : '📎 Add files'}
        </button>
        <input ref={ref} type="file" multiple accept={accept} onChange={handleFiles} style={{ display: 'none' }} />
        {paths.length === 0 && !uploading && <span style={{ fontSize: 12, color: '#aaa' }}>No files — you can select several at once</span>}
      </div>
      {paths.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {paths.map(p => (
            <div key={p} style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f9f8f5', borderRadius: 6, padding: '5px 10px' }}>
              <span style={{ fontSize: 12, color: '#3B6D11', fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>✓ {fileName(p)}</span>
              <button type="button" onClick={() => removeFile(p)} style={{ background: 'none', border: 'none', color: '#A32D2D', fontSize: 14, cursor: 'pointer', padding: '0 4px', lineHeight: 1 }}>×</button>
            </div>
          ))}
        </div>
      )}
      {err && <div style={{ fontSize: 12, color: '#A32D2D', marginTop: 4 }}>{err}</div>}
    </div>
  );
}
